import { connectHook } from 'app/common/components/connect-hook';
import { AgentEvalRunEdit } from './agent-eval-run-edit';
import { useAgentEvalRunEdit } from './agent-eval-run-edit-hook';

export default connectHook(AgentEvalRunEdit, useAgentEvalRunEdit);
